import { render, staticRenderFns } from "./ProArtists.vue?vue&type=template&id=4abaa572&scoped=true"
import script from "./ProArtists.vue?vue&type=script&lang=ts"
export * from "./ProArtists.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abaa572",
  null
  
)

export default component.exports